module.exports = __webpack_public_path__ + "static/img/05.8cb4f72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour2/05.jpg
// module id = /rKA
// module chunks = 0